<template lang="">
    <div id="template-editor">
        <h4 class="mb-8 text-center underline font-bold italic">{{template_data.name || ''}}</h4>
        <div class="mb-4 flex ml-auto mr-0">
            <vs-button color="primary" type="filled" @click="saveTemplate" icon-pack="feather" icon="icon-save" class="mr-2">
                Save Template
            </vs-button>
            <vs-button color="primary" type="border" @click="generatePDF" icon-pack="feather" icon="icon-file-text" class="mr-2">
                Generate PDF [TEST SO-000780]
            </vs-button>

        </div>
        <div class="editor-wrapper">
            <div class="gjs-blocks hidden" id="blocks"></div>
            <div ref="gjsEditor" class="gjs-editor"></div>
        </div>
    </div>
</template>
<script>
import grapesjs from 'grapesjs';
import gjsBlocksBasic from 'grapesjs-blocks-basic';
import 'grapesjs/dist/css/grapes.min.css';

import { RepositoryFactory } from '@/repository/RepositoryFactory';
const DocumentTemplateRepository = RepositoryFactory.get('document_template');

import ErrorMessages from '@/mixins/ErrorMessages'

export default {
    name: "CrmBuilderMain",
    async mounted() {
        this.template_id = this.$route.params.template_id;
        await this.fetchTemplateData()
        this.initEditor();
    },
    mixins : [ ErrorMessages ],
    data() {
        return {
            editor: null,
            template_id: null,
            template_data: {},
            defaultTemplate: `
            <div style="width: 210mm; max-width: 100%; margin: 20px auto; padding: 20px; background-color: #fff; border: 1px solid #ccc; box-sizing: border-box;">
    
    <h1 style="text-align: center; color: #333;">Invoice</h1>
    
    <p style="margin-bottom: 20px;">
        <strong>From:</strong><br>
        Your Company Name<br>
        123 Company Address<br>
        City, State ZIP<br>
        Email: company@example.com<br>
        Phone: (123) 456-7890
    </p>
    
    <p style="margin-bottom: 20px;">
        <strong>To:</strong><br>
        Customer Name<br>
        456 Customer Address<br>
        City, State ZIP<br>
        Email: customer@example.com<br>
        Phone: (987) 654-3210
    </p>
    
    <p style="margin-bottom: 20px;">
        <strong>Invoice Number:</strong> 001<br>
        <strong>Date:</strong> 2025-10-01
    </p>
    
    <table style="width: 100%; border-collapse: collapse;" border="1" cellpadding="5" cellspacing="0">
        <tr style="background-color: #f2f2f2;">
            <th style="padding: 10px;">#</th>
            <th style="padding: 10px;">Description</th>
            <th style="padding: 10px;">Quantity</th>
            <th style="padding: 10px;">Unit Price</th>
            <th style="padding: 10px;">Total</th>
        </tr>
        <tr>
            <td style="padding: 10px; text-align: center;">1</td>
            <td style="padding: 10px;">Product/Service 1</td>
            <td style="padding: 10px; text-align: center;">2</td>
            <td style="padding: 10px; text-align: right;">$50</td>
            <td style="padding: 10px; text-align: right;">$100</td>
        </tr>
        <tr>
            <td style="padding: 10px; text-align: center;">2</td>
            <td style="padding: 10px;">Product/Service 2</td>
            <td style="padding: 10px; text-align: center;">1</td>
            <td style="padding: 10px; text-align: right;">$75</td>
            <td style="padding: 10px; text-align: right;">$75</td>
        </tr>
        <tr>
            <td colspan="4" style="padding: 10px; text-align: right;"><strong>Subtotal</strong></td>
            <td style="padding: 10px; text-align: right;">$175</td>
        </tr>
        <tr>
            <td colspan="4" style="padding: 10px; text-align: right;"><strong>Tax (10%)</strong></td>
            <td style="padding: 10px; text-align: right;">$17.50</td>
        </tr>
        <tr>
            <td colspan="4" style="padding: 10px; text-align: right;"><strong>Total</strong></td>
            <td style="padding: 10px; text-align: right;">$192.50</td>
        </tr>
    </table>
    
    <p style="margin-top: 20px;">
        <strong>Notes:</strong><br>
        Thank you for your business!
    </p>

</div>
            `
        };
    },
    methods: {
        initEditor() {
            this.editor = grapesjs.init({
                container: this.$refs.gjsEditor,
                fromElement: false,      // we supply components programmatically
                height: '1000px',
                storageManager: {
                    id: 'gjs-',           // Prefix for storing projects (you can disable or configure)
                    type: 'local',        // change if you want server storage via plugin
                    autosave: false,
                },
                blockManager: {
                    appendTo: '#blocks'
                },
                plugins: [gjsBlocksBasic],
                pluginsOpts: {
                    [gjsBlocksBasic]: { flexGrid: true }
                }
                // You can disable panels you don't need or add custom commands/panels
            });
            // Load initial template into editor as components + style
            this.editor.setComponents(this.template_data.html_content);
            // this.editor.setStyle(''); // optional: set CSS string

            // Add custom block: Invoice Row
            this.editor.BlockManager.add('invoice-row', {
                label: 'Invoice Row',
                category: 'Invoice',
                content: `
          <tr>
            <td style="margin-bottom: 20px;">{{item_name}}</td>
            <td style="margin-bottom: 20px;">{{quantity}}</td>
            <td style="margin-bottom: 20px;">{{price}}</td>
            <td style="margin-bottom: 20px;">{{line_total}}</td>
          </tr>
        `
            });

            // Add placeholder blocks
            const placeholders = [
                { id: 'ph-invoice-number', label: 'Invoice Number', tag: '{{invoice_number}}' },
                { id: 'ph-invoice-date', label: 'Invoice Date', tag: '{{invoice_date}}' },
                { id: 'ph-customer-name', label: 'Customer Name', tag: '{{customer_name}}' },
                { id: 'ph-total', label: 'Total Amount', tag: '{{total_amount}}' }
            ];

            placeholders.forEach(ph => {
                this.editor.BlockManager.add(ph.id, {
                    label: ph.label,
                    category: 'Placeholders',
                    content: `<span>${ph.tag}</span>`
                });
            });
        },
        async fetchTemplateData() {
            await this.$vs.loading({
                container: '#template-editor',
                scale: 0.45
            })
            try {
                const { data } = (await DocumentTemplateRepository.getTemplateData(this.template_id)).data
                this.template_data = data
            } catch (error) {
                console.error(error)
            } finally {
                this.$vs.loading.close('#template-editor > .con-vs-loading')
            }
        },
        async saveTemplate() {
            if (!this.editor) return;
            const htmlContent = this.editor.getHtml();
            const cssContent = this.editor.getCss();
         
            const fullHtml = `
                <style>${cssContent}</style>
                ${htmlContent}
            `;
            try {
                let payload =  this.template_data
                payload.html_content = fullHtml
                await DocumentTemplateRepository.updateTemplate(this.template_id, payload)
                await this.fetchTemplateData()
                await this.initEditor()
            } catch (error) {
                
            }
        },
        async generatePDF() {
            try {
                await DocumentTemplateRepository.generatePdf({
                    type: this.template_data.name,
                    id: '145' //nimble dev sales quote ID
                })
            } catch (error) {
                this.showErrorMessage('An error occurred while generating the PDF')
            }
        }
    }
}
</script>
<style scoped>
.editor-wrapper {
    display: flex;
    border: 1px solid #ccc;
}

.gjs-blocks {
    width: 250px;
    border-right: 1px solid #ccc;
    background: #f9f9f9;
    overflow-y: auto;
}

.gjs-editor {
    flex: 1;
    min-height: 700px;
}

.controls {
    margin-bottom: 10px;
}

.controls button {
    margin-right: 8px;
}
</style>